import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "store";

export default function useProfilePointHistory(history: any) {
  const { language } = useSelector((state: RootState) => state.lang);

  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [modifiedPointHistory, setModifiedPointHistory] = useState<any>([]);

  const { t } = useTranslation();

  const _onOpen = (): void => {
    setIsShowModal(true);
  };

  const _onClose = (): void => {
    setIsShowModal(false);
  };

  const getPointData = (type: number, remarks: string) => {
    switch (type) {
      case 0:
        return {
          icon: "la-tags",
          color: "green",
          title: t("profile_point_his_system_promotion"),
          remarks: remarks,
        };
      case 1:
        return {
          icon: "la-shopping-bag",
          color: "red",
          title: t("profile_point_his_system_redeem"),
          remarks: remarks,
        };
      case 2:
        return {
          icon: "la-exchange-alt",
          color: "indigo",
          title: t("profile_point_his_system_distribution"),
          remarks: remarks,
        };
    }
  };

  useEffect(() => {
    if (!history || history.length < 1) return;

    const tmp = history
      .sort((a: any, b: any) => Date.parse(b.created_at) - Date.parse(a.created_at))
      .map((i: any) => {
        const data = {
          point_id: i.organization_user_point_id,
          value: i.value,
          date: moment(i.created_at).format("YYYY-MM-DD HH:mm"),
        };

        return { ...data, ...getPointData(i.type, i.remarks) };
      });

    setModifiedPointHistory(tmp);
  }, [history, language]);

  return { modifiedPointHistory, isShowModal, _onOpen, _onClose };
}
